import { Helmet, HelmetProvider } from 'react-helmet-async';
import {
    Typography,
    Stack,
    Grid,
    Card,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    InputAdornment,
    Chip,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Divider
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
// Gerekli kütüphaneler
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import api from 'src/services/BaseService'; // Projenizdeki API servisi yolu
import { tokenService } from 'src/services';
import Services from 'src/services/Services';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { StatusList } from 'src/types/statusTypes';

// ----------------------------------------------------------------------
// SVG İkonları ve Yardımcı Bileşenler
// ----------------------------------------------------------------------

const RedLineChartSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="99" height="51" viewBox="0 0 99 51" fill="none">
            <mask id="mask0_40_756" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="1" y="1" width="97" height="49">
                <rect width="96" height="48" transform="translate(1.948 1.60309)" fill="url(#paint0_linear_40_756)" />
            </mask>
            <g mask="url(#mask0_40_756)">
                <path opacity="0.2" d="M1.948 1.60309C17.5449 2.90283 18.5108 34.0195 33.948 37.6031C46.6778 40.5582 53.1239 23.7834 65.948 25.6031C79.8577 27.5768 84.3089 45.0567 97.948 49.6031H1.948V1.60309Z" fill="#F04438" />
            </g>
            <path d="M97.948 49.6031C84.3089 45.0567 79.8577 27.5768 65.948 25.6031C53.1239 23.7834 46.6778 40.5582 33.948 37.6031C18.5108 34.0195 17.5449 2.90283 1.948 1.60309" stroke="#F04438" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <g opacity="0.2">
                <rect x="73.448" y="28.1031" width="14.5" height="14.5" rx="7.25" stroke="#F04438" strokeWidth="2" />
            </g>
            <rect x="77.198" y="31.8531" width="7" height="7" rx="3.5" fill="white" />
            <rect x="77.198" y="31.8531" width="7" height="7" rx="3.5" stroke="#F04438" strokeWidth="2" />
            <defs>
                <linearGradient id="paint0_linear_40_756" x1="48" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const GreenLineChartSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="99" height="51" viewBox="0 0 99 51" fill="none">
            <mask id="mask0_40_605" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="1" y="1" width="97" height="49">
                <rect width="96" height="48" transform="translate(1.448 1.1031)" fill="url(#paint0_linear_40_605)" />
            </mask>
            <g mask="url(#mask0_40_605)">
                <path opacity="0.2" d="M97.448 1.1031C81.8511 2.40285 80.8852 33.5195 65.448 37.1031C52.7182 40.0583 46.2721 23.2835 33.448 25.1031C19.5383 27.0768 15.0871 44.5567 1.448 49.1031H97.448V1.1031Z" fill="#17B26A" />
            </g>
            <path d="M1.448 49.1031C15.0871 44.5567 19.5383 27.0768 33.448 25.1031C46.2721 23.2835 52.7182 40.0582 65.448 37.1031C80.8852 33.5195 81.8511 2.40285 97.448 1.1031" stroke="#17B26A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <g opacity="0.2">
                <rect x="72.948" y="12.6031" width="14.5" height="14.5" rx="7.25" stroke="#17B26A" strokeWidth="2" />
            </g>
            <rect x="76.698" y="16.3531" width="7" height="7" rx="3.5" fill="white" />
            <rect x="76.698" y="16.3531" width="7" height="7" rx="3.5" stroke="#17B26A" strokeWidth="2" />
            <defs>
                <linearGradient id="paint0_linear_40_605" x1="48" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
const BoxIcon = ({ size = 32, color = 'currentColor' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" >
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8333 3.33331H4.16667C3.24619 3.33331 2.5 4.0795 2.5 4.99998V16.6666C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6666V4.99998C17.5 4.0795 16.7538 3.33331 15.8333 3.33331Z" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.3333 1.66669V5.00002" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.66669 1.66669V5.00002" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.5 8.33331H17.5" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);


const SearchIcon = ({ size = 20, color = 'currentColor' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
);

const getMallId = () => {
    const userString = localStorage.getItem('user');
    if (userString) {
        try {
            const userObject = JSON.parse(userString);
            return userObject.mallID;
        } catch (e) {
            console.error("Kullanıcı verisi parse edilirken hata!", e);
            return null;
        }
    }
    return null;
};


const OperationDensityChart = ({ percentage }) => {
    console.log("Percentage : ", percentage)
    const theme = useTheme();
    const colorLightBlue = '#C1D3F8';
    const colorMediumBlue = '#6FA0FF';
    const colorDarkBlue = '#1C64F2';
    const radius = 79;
    const strokeWidth = 28;
    const viewBoxWidth = 186;
    const viewBoxHeight = 107;
    const cx = viewBoxWidth / 2;
    const cy = viewBoxHeight;
    // Eğer yüzde 100'den büyükse, çizgiyi max'a sabitle
    const cappedPercentage = Math.min(Number(percentage), 100);
    const angle = 180 + (cappedPercentage / 100) * 180;
    const angleRad = angle * Math.PI / 180;
    const innerRadius = radius - strokeWidth / 2;
    const outerRadius = radius + strokeWidth / 2;
    const x1 = cx + innerRadius * Math.cos(angleRad);
    const y1 = cy + innerRadius * Math.sin(angleRad);
    const x2 = cx + outerRadius * Math.cos(angleRad);
    const y2 = cy + outerRadius * Math.sin(angleRad);
    return (
        <Card sx={{ padding: '12px 24px', height: '100%', maxWidth: { xs: '100%', lg: 288 }, mx: 'auto', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: 'success.main', mr: 1 }} />Operasyon Yoğunluğu</Typography>
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Box sx={{ position: 'relative', maxWidth: 186, width: '100%', mx: 'auto' }}>
                    <Tooltip title={`${percentage.toLocaleString('tr-TR', { maximumFractionDigits: 1 })}%`} arrow>
                        <svg width="100%" viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} preserveAspectRatio="xMidYMax meet">
                            <defs><linearGradient id="densityGradient" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor={colorLightBlue} /><stop offset="50%" stopColor={colorMediumBlue} /><stop offset="100%" stopColor={colorDarkBlue} /></linearGradient></defs>
                            <path d={`M ${cx - radius},${cy} A ${radius},${radius} 0 0 1 ${cx + radius},${cy}`} fill="none" stroke="url(#densityGradient)" strokeWidth={strokeWidth} />
                            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="white" strokeWidth="3" />
                        </svg>
                    </Tooltip>
                    <Box sx={{ position: 'absolute', top: '75%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
                        <Typography variant="h4" component="div" sx={{ fontSize: 18, lineHeight: '30px' }}>{percentage.toLocaleString('tr-TR', { maximumFractionDigits: 1 })}%</Typography>
                        <Typography variant="body2" color="text.secondary" fontSize={14} sx={{ whiteSpace: 'pre' }} >{percentage > 100 ? 'Çok Yoğun' : 'Orta Yoğunlukta'}</Typography>
                    </Box>
                </Box>
                <Stack direction="row" justifyContent="space-between" sx={{ maxWidth: 186, width: '100%', mx: 'auto', px: '2%' }}><Typography variant="caption" color="text.secondary">Min</Typography><Typography variant="caption" color="text.secondary">Max</Typography></Stack>
            </Box>
            <Stack direction="row" justifyContent="center" spacing={2} sx={{ mt: 1, borderTop: `1px solid #E5E7EB`, pt: 1.5 }}><Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colorLightBlue, mr: 1 }} />Düşük</Typography><Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colorMediumBlue, mr: 1 }} />Orta</Typography><Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colorDarkBlue, mr: 1 }} />Yoğun</Typography></Stack>
        </Card>
    );
};

const DonutChart = ({ title, value, subValue, data, size, showTotalInCenter }) => {
    const theme = useTheme();
    const radius = size / 2;
    const stroke = size / 8;
    const normalizedRadius = radius - stroke / 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const total = data.reduce((acc, item) => acc + Number(item.value), 0);
    let cumulativeOffset = 0;

    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'unset' }}>
            <Typography variant="subtitle2" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#399B52', mr: 1 }} />
                {title}
            </Typography>
            <Box sx={{ flexGrow: 1, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', my: 2 }}>
                <svg height={size} width={size} viewBox={`0 0 ${size} ${size}`}>
                    <circle stroke={theme.palette.grey[200]} fill="transparent" strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />
                    {data.map((item, index) => {
                        const offset = (Number(item.value) / total) * circumference;
                        const dasharray = `${offset} ${circumference - offset}`;
                        const rotation = (cumulativeOffset / total) * 360;
                        const percent = total > 0 ? Math.round((Number(item.value) / total) * 100) : 0;
                        const tooltipText = `${item.name}: ${item.value} (%${percent})`;
                        const el = (
                            <circle key={index} stroke={item.color} fill="transparent" strokeWidth={stroke} strokeDasharray={dasharray} style={{ transform: `rotate(${rotation - 90}deg)`, transformOrigin: '50% 50%' }} r={normalizedRadius} cx={radius} cy={radius} />
                        );
                        cumulativeOffset += Number(item.value);
                        return (
                            <Tooltip key={index} title={tooltipText} arrow>
                                {el}
                            </Tooltip>
                        );
                    })}
                </svg>
                <Box sx={{ position: 'absolute', textAlign: 'center', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                    {showTotalInCenter ? (
                        <>
                            <Typography variant="p" fontWeight={500}>Toplam <br /> Adet</Typography>
                            <Typography variant="h6" color="text.primary">{total}</Typography>
                        </>
                    ) : (
                        <>
                            <Typography variant="h5">{value}</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ px: 1 }}>{subValue}</Typography>
                        </>
                    )}
                </Box>
            </Box>
            <Stack direction="row" justifyContent="center" flexWrap="wrap" columnGap={2} rowGap={1} sx={{ pt: 2, mt: 'auto', borderTop: '1px solid #E5E7EB' }}>
                {data.map(item => (
                    <Typography variant="body2" key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: item.color, mr: 1 }} />
                        {item.name}:
                        <Typography component="span" variant="body2" color="text.secondary" fontWeight="bold" sx={{ ml: 0.5 }}>
                            {item.value}
                        </Typography>
                    </Typography>
                ))}
            </Stack>
        </Card>
    );
}

const GaugeChart = ({ title, value, subValue, percentage, legendItems }) => {
    const theme = useTheme();
    const width = 236;
    const height = 117;
    const strokeWidth = 35;
    const radius = width / 2 - strokeWidth / 2;
    const cx = width / 2;
    const cy = height;
    const circumference = radius * Math.PI;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;
    const pathD = `M ${cx - radius},${cy} A ${radius},${radius} 0 0 1 ${cx + radius},${cy}`;

    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#F79009', mr: 1 }} />
                {title}
            </Typography>
            <Box sx={{ flexGrow: 1, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', my: 2, width: '100%', height: `${height}px` }}>
                <Tooltip title={`Açıkta Bekleyen Oran: ${percentage.toLocaleString('tr-TR', { maximumFractionDigits: 1 })}%`} arrow>
                    <svg width="100%" height="100%" viewBox={`0 0 ${width} ${height}`}>
                        <path d={pathD} stroke={legendItems[1].color} fill="none" strokeWidth={strokeWidth} strokeLinecap="butt" />
                        <path d={pathD} stroke={legendItems[0].color} fill="none" strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="butt" />
                    </svg>
                </Tooltip>
                <Box sx={{ position: 'absolute', textAlign: 'center', bottom: 25 }}>
                    <Typography variant="h4" fontWeight="bold">{value}</Typography>
                    <Typography variant="body2" color="text.secondary">{subValue}</Typography>
                </Box>
            </Box>
            <Stack direction="row" justifyContent="center" flexWrap="wrap" columnGap={2} rowGap={1} sx={{ pt: 2, mt: 'auto', borderTop: '1px solid #E5E7EB' }}>
                {legendItems.map(item => (
                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }} key={item.name}>
                        <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: item.color, mr: 1 }} />
                        {item.name}
                    </Typography>
                ))}
            </Stack>
        </Card>
    );
}

const GroupedBarChart = ({ data }) => {
    const theme = useTheme();
    const maxValue = 1300;
    const colors = { delivered: theme.palette.primary.main, pending: theme.palette.info.light };

    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" color="text.secondary">Mal Kabulde Bulunan Gönderiler</Typography>
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', mt: 2, minHeight: 350, overflowX: 'auto', pb: 1 }}>
                <Stack direction="row" spacing={2} sx={{ height: '100%', minWidth: 600, alignItems: 'flex-end', pl: 4, position: 'relative' }}>
                    <Stack sx={{ position: 'absolute', left: 0, top: 0, bottom: '24px', justifyContent: 'space-between', textAlign: 'right', pr: 1, height: 'calc(100% - 24px)' }}>
                        {[...Array(6)].map((_, i) => <Typography key={i} variant="caption" color="text.secondary">{1250 - i * 250}</Typography>)}
                    </Stack>
                    {data.map((item, index) => (
                        <Stack key={index} sx={{ flex: 1, height: '100%', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <Stack direction="row" sx={{ height: `calc(100% - 24px)`, width: '100%', alignItems: 'flex-end', justifyContent: 'center', gap: '10%' }}>
                                <Tooltip title={`Teslim Edilen: ${item.delivered}`} arrow>
                                    <Box sx={{ width: '35%', height: `${(item.delivered / maxValue) * 100}%`, backgroundColor: colors.delivered, borderRadius: '4px 4px 0 0' }} />
                                </Tooltip>
                                <Tooltip title={`Bekleyen: ${item.pending}`} arrow>
                                    <Box sx={{ width: '35%', height: `${(item.pending / maxValue) * 100}%`, backgroundColor: colors.pending, borderRadius: '4px 4px 0 0' }} />
                                </Tooltip>
                            </Stack>
                            <Typography variant="caption" sx={{ mt: 0.5, whiteSpace: 'nowrap' }}>{item.name}</Typography>
                        </Stack>
                    ))}
                </Stack>
            </Box>
            <Typography variant="caption" sx={{ textAlign: 'center', fontSize: '12px', mb: 1, color: '#C6BBBB' }}>Kargo Firmaları</Typography>
            <Stack direction="row" justifyContent="center" spacing={2} sx={{ borderTop: `1px solid ${theme.palette.divider}`, pt: 1.5 }}>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colors.delivered, mr: 1 }} />Teslim Edilen Paketler</Typography>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colors.pending, mr: 1 }} />Bekleyen Paketler</Typography>
            </Stack>
        </Card>
    );
};

const PieChart = () => {
    const theme = useTheme();
    const data = [
        { name: 'Aktif Porter', value: 85, color: theme.palette.primary.main },
        { name: 'Pasif Porter', value: 15, color: theme.palette.info.light }
    ];
    const total = data.reduce((acc, item) => acc + item.value, 0);
    let cumulative = 0;
    const paths = data.map(item => {
        const percentage = item.value / total;
        const startAngle = (cumulative / total) * 360 - 90;
        cumulative += item.value;
        const endAngle = (cumulative / total) * 360 - 90;
        const largeArcFlag = percentage > 0.5 ? 1 : 0;
        const startX = 50 + 50 * Math.cos(Math.PI * (startAngle / 180));
        const startY = 50 + 50 * Math.sin(Math.PI * (startAngle / 180));
        const endX = 50 + 50 * Math.cos(Math.PI * (endAngle / 180));
        const endY = 50 + 50 * Math.sin(Math.PI * (endAngle / 180));
        return `M 50,50 L ${startX},${startY} A 50,50 0 ${largeArcFlag},1 ${endX},${endY} Z`;
    });

    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: 'success.main', mr: 1 }} />
                Aktif/Pasif Porter Oranı
            </Typography>
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', my: 2 }}>
                <svg viewBox="0 0 100 100" width="150" height="150">
                    {paths.map((d, i) => <path key={i} d={d} fill={data[i].color} />)}
                </svg>
            </Box>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                {data.map(item => (
                    <Stack direction="row" justifyContent="space-between" key={item.name}>
                        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: item.color, mr: 1 }} />
                            {item.name}: <Typography variant="body2" color="text.secondary" marginLeft="2px" fontWeight="bold">{item.value}</Typography>
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Card>
    )
}

const PorterWorkloadChart = ({ livePostTracking }) => {
    const theme = useTheme();
    // Porter bazlı iş yükü: { [porterName]: { [toolType]: count } }
    const porterMap = {};
    if (Array.isArray(livePostTracking)) {
        livePostTracking.forEach(item => {
            const name = (item.porterName || '') + (item.porterLastname ? ' ' + item.porterLastname : '');
            if (!porterMap[name]) porterMap[name] = {};
            const tool = item.transportationTool || 'Diğer';
            porterMap[name][tool] = (porterMap[name][tool] || 0) + Number(item.transportationToolCount || 1);
        });
    }
    // Tüm araç tiplerini bul
    const allTools = Array.from(new Set(Object.values(porterMap).flatMap(obj => Object.keys(obj))));
    const data = Object.entries(porterMap).map(([name, tools]) => ({
        name,
        values: allTools.map(tool => tools[tool] || 0)
    }));
    const maxValue = Math.max(10, ...data.flatMap(d => d.values));
    const colors = allTools.map((tool, idx) => [theme.palette.primary.main, theme.palette.info.main, theme.palette.info.light, '#F79009', '#A259F7', '#FF6B6B'][idx % 6]);
    // Bar kalınlığını artırmak için width'i yükseltiyorum
    const barWidth = Math.max(18, 60 / allTools.length);

    console.log("Porter Data : ", data)
    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" color="text.secondary">
                <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: theme.palette.primary.main, mr: 1 }} />
                Porter Bazlı İş Yükü Dağılımı
            </Typography>
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', mt: 2, minHeight: 300, overflowX: 'auto', pb: 1 }}>
                <Stack direction="row" spacing={2} sx={{ height: '100%', minWidth: 100 + 60 * data.length, alignItems: 'flex-end', pl: 4, position: 'relative' }}>
                    <Stack sx={{ position: 'absolute', left: 0, top: 0, bottom: '24px', justifyContent: 'space-between', textAlign: 'right', pr: 1, height: 'calc(100% - 24px)' }}>
                        {[...Array(6)].map((_, i) => <Typography key={i} variant="caption" color="text.secondary">{Math.round(maxValue - i * (maxValue / 5))}</Typography>)}
                    </Stack>
                    {data.map(item => (
                        <Stack key={item.name} sx={{ flex: 1, height: '100%', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <Stack direction="row" sx={{ height: `calc(100% - 24px)`, width: '100%', alignItems: 'flex-end', justifyContent: 'center' }}>
                                {item.values.map((val, index) => (
                                    val > 0 ? (
                                        <Tooltip key={index} title={`${allTools[index]}: ${val}`} arrow>
                                            <Box sx={{ width: '18px', minWidth: 14, height: `${(val / maxValue) * 100}%`, backgroundColor: colors[index], borderRadius: '4px 4px 0 0', mx: 0.5 }} />
                                        </Tooltip>
                                    ) : null
                                ))}
                            </Stack>
                            <Typography variant="caption" sx={{ mt: 0.5, whiteSpace: 'nowrap' }}>{item.name}</Typography>
                        </Stack>
                    ))}
                </Stack>
            </Box>
            <Typography variant="caption" sx={{ textAlign: 'center', fontSize: '12px', mb: 1, color: '#C6BBBB' }}>Porter Adı</Typography>
            <Stack direction="row" justifyContent="center" spacing={2} flexWrap="wrap" rowGap={1} sx={{ borderTop: `1px solid ${theme.palette.divider}`, pt: 1.5 }}>
                {allTools.map((tool, idx) => (
                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }} key={tool}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colors[idx], mr: 1 }} />{tool}</Typography>
                ))}
            </Stack>
        </Card>
    );
};

const formatSecondsToMinSec = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    return `${min}:${sec.toString().padStart(2, '0')}`;
};

const PorterCompletionChart = ({ portersPostCompletionMedian, allPorterPostCompletionMedian }) => {
    const theme = useTheme();
    const data = Array.isArray(portersPostCompletionMedian) ? portersPostCompletionMedian : [];
    const maxValue = Math.max(10, ...data.map(d => d.averageCompletionTimeSeconds));
    const colors = [theme.palette.primary.main];
    return (
        <Card sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" color="text.secondary">
                <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: theme.palette.primary.main, mr: 1 }} />
                Porter İşleri Tamamlama Süresi
            </Typography>
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', mt: 2, minHeight: 300, overflowX: 'auto', pb: 1 }}>
                {data.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 8 }}>Veri yok</Typography>
                ) : (
                    <Stack direction="row" spacing={2} sx={{ height: '100%', minWidth: 500, alignItems: 'flex-end', pl: 4, position: 'relative' }}>
                        <Stack sx={{ position: 'absolute', left: 0, top: 0, bottom: '24px', justifyContent: 'space-between', textAlign: 'right', pr: 1, height: 'calc(100% - 24px)' }}>
                            {[...Array(6)].map((_, i) => <Typography key={i} variant="caption" color="text.secondary">{Math.round(maxValue - i * (maxValue / 5))}</Typography>)}
                        </Stack>
                        {data.map(item => (
                            <Stack key={item.fullName} sx={{ flex: 1, height: '100%', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <Stack direction="row" sx={{ height: `calc(100% - 24px)`, width: '100%', alignItems: 'flex-end', justifyContent: 'center', gap: '10%' }}>
                                    <Tooltip title={`Süre: ${item.averageCompletionTimeSeconds} sn (${formatSecondsToMinSec(item.averageCompletionTimeSeconds)})`} arrow>
                                        <Box sx={{ width: '60%', height: `${(item.averageCompletionTimeSeconds / maxValue) * 100}%`, backgroundColor: colors[0], borderRadius: '4px 4px 0 0' }} />
                                    </Tooltip>
                                </Stack>
                                <Typography variant="caption" sx={{ mt: 0.5, whiteSpace: 'nowrap' }}>{item.fullName}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                )}
            </Box>
            <Typography variant="caption" sx={{ textAlign: 'center', fontSize: '12px', mb: 1, color: '#C6BBBB' }}>Porter Adı</Typography>
            <Stack direction="row" justifyContent="center" spacing={2} sx={{ borderTop: `1px solid ${theme.palette.divider}`, pt: 1.5 }}>
                <Tooltip title={`Ortalama: ${allPorterPostCompletionMedian} sn (${formatSecondsToMinSec(allPorterPostCompletionMedian)})`} arrow>
                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colors[0], mr: 1 }} />Tamamlama Süresi (dk:sn)</Typography>
                </Tooltip>
                <Tooltip title={`Ortalama: ${allPorterPostCompletionMedian} sn (${formatSecondsToMinSec(allPorterPostCompletionMedian)})`} arrow>
                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#E5E7EB', mr: 1 }} />Ortalama: {allPorterPostCompletionMedian ? formatSecondsToMinSec(allPorterPostCompletionMedian) : '-'} dk ({allPorterPostCompletionMedian ? allPorterPostCompletionMedian : '-'} sn)</Typography>
                </Tooltip>
            </Stack>
        </Card>
    );
};

const LiveTrackingTable = ({ livePostTracking }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const theme = useTheme();
    // Eğer veri yoksa boş array
    const data = Array.isArray(livePostTracking) ? livePostTracking : [];
    // Tabloya uygun şekilde mapping
    const tableRows = data.map((row, idx) => {
        // direction ve directionTitle'a göre çıkış/varış noktası
        let exitPoint = '';
        let entryPoint = '';
        if (row.direction === 'StoreToMallLogistics') {
            exitPoint = 'Store/Mağaza';
            entryPoint = 'Mall Logistics';
        } else if (row.directionTitle) {
            // directionTitle varsa, sol/sağ ayır
            const parts = row.directionTitle.split(' ');
            if (parts.length >= 3) {
                exitPoint = parts[0];
                entryPoint = parts[2];
            } else {
                exitPoint = row.directionTitle;
                entryPoint = '';
            }
        } else {
            exitPoint = row.branchTitle || '';
            entryPoint = row.pointTitle || '';
        }
        return {
            id: idx + 1,
            porterName: row.porterName + (row.porterLastname ? ' ' + row.porterLastname : ''),
            status: row.porterStatus === '1' ? 'Aktif' : 'Pasif',
            docNo: '', // API'de yok, boş bırakıyoruz
            exitPoint,
            entryPoint,
            vehicleType: row.transportationTool || '-',
            quantity: row.transportationToolCount || '-',
            jobStatus: row.postStatusTitle || '-',
            jobType: row.apiUserType || '-',
            senderType: row.branchTitle || '-',
        };
    });
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <Card>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Typography variant="h6">Canlı İş Akış Takibi</Typography>
                <TextField
                    placeholder="Porter adı ara..."
                    variant="outlined"
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                        },
                        minWidth: { sm: 300 }
                    }}
                />
            </Box>
            <TableContainer>
                <Table sx={{ minWidth: 1200 }}>
                    <TableHead sx={{ backgroundColor: theme.palette.grey[100] }}>
                        <TableRow>
                            <TableCell>PORTER ADI</TableCell>
                            <TableCell>DURUMU</TableCell>
                            <TableCell>BELGE NO</TableCell>
                            <TableCell>ÇIKIŞ NOKTASI</TableCell>
                            <TableCell>VARIŞ NOKTASI</TableCell>
                            <TableCell>ARAÇ TİPİ</TableCell>
                            <TableCell>ADET</TableCell>
                            <TableCell>STATÜ</TableCell>
                            <TableCell>İŞLEM TİPİ</TableCell>
                            <TableCell>GÖNDERİ TİPİ</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                            <TableRow key={row.id} hover>
                                <TableCell>{row.porterName}</TableCell>
                                <TableCell>
                                    <Chip
                                        label={row.status}
                                        sx={{
                                            height: 22,
                                            minWidth: 45,
                                            borderRadius: '20px',
                                            backgroundColor: row.status === 'Aktif' ? '#F0FDF4' : '#FAFAFA',
                                            color: row.status === 'Aktif' ? '#17B26A' : '#737373',
                                            border: `1px solid ${row.status === 'Aktif' ? '#BBF7D0' : '#E5E5E5'}`
                                        }}
                                    />
                                </TableCell>
                                <TableCell>{row.docNo}</TableCell>
                                <TableCell>{row.exitPoint}</TableCell>
                                <TableCell>{row.entryPoint}</TableCell>
                                <TableCell>{row.vehicleType}</TableCell>
                                <TableCell>{row.quantity}</TableCell>
                                <TableCell>{row.jobStatus}</TableCell>
                                <TableCell>{row.jobType}</TableCell>
                                <TableCell>{row.senderType}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={tableRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Card>
    );
}

const ReportGenerator = () => {
    const theme = useTheme();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [reportType, setReportType] = useState('tasima');
    const [loading, setLoading] = useState(false);

    // Bu sayfa tek bir AVM'yi gösterdiği için, ID'yi localStorage'dan alıyoruz.
    const getMallId = () => {
        const userString = localStorage.getItem('user');
        if (userString) {
            try {
                const userObject = JSON.parse(userString);
                // authLocations içindeki ilk AVM'nin ID'sini alıyoruz.
                if (userObject?.authLocations?.mall?.length > 0) {
                    return userObject.authLocations.mall[0].id;
                }
                // Fallback olarak doğrudan mallID'yi arıyoruz.
                return userObject.mallID || null;
            } catch (e) {
                console.error("Kullanıcı verisi parse edilirken hata!", e);
                return null;
            }
        }
        return null;
    };

    const exportApiCall = (data, headers, sheetTitle) => {
        return api.post('excel/export', {
            type: 'excel',
            content: data,
            header: headers,
            sheetTitle: sheetTitle,
        }).then((response) => {
            if (response.data.status) {
                window.open(response.data.result, '_blank');
            } else {
                throw new Error(response.data.message || 'Excel dosyası oluşturulamadı.');
            }
        });
    };

    const handleTasimaRaporu = async () => {
        const start = startDate.format('YYYY-MM-DD');
        const end = endDate.format('YYYY-MM-DD');
        const mallId = getMallId();
        const mallTitle = getMallTitleById(mallId);

        if (!mallId) {
            toast.error("Rapor için AVM ID bulunamadı.");
            return;
        }

        const response = await axios.get(`https://system.easypointapi.com/handshakes-report-view-json.php?start=${start}&end=${end}&mall=${mallId}`);

        if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
            toast.info('Taşıma raporu için veri bulunamadı.');
            return;
        }

        const allDataRows = response.data;

        // --- 1. EXCEL: HAM VERİ RAPORU ---
        const rawExcelData = allDataRows.map(row => ({ 'Proje': row[0], 'Tarih': row[1], 'İrsaliye No': row[2], 'Talep No': row[3], 'Saat': row[4], 'Mağaza': row[5], 'Sefer Sayısı': row[6], 'Araç Tipi': row[7], 'Taşıma Personel': row[8], 'QR Tip': row[9], 'Kabul Eden': row[10], 'Toplam Paket Adedi': row[11], 'Hareket Yönü': row[12], 'Not': row[13] }));
        const rawHeaders = { 'Proje': 'string', 'Tarih': 'string', 'İrsaliye No': 'string', 'Talep No': 'string', 'Saat': 'string', 'Mağaza': 'string', 'Sefer Sayısı': 'string', 'Araç Tipi': 'string', 'Taşıma Personel': 'string', 'QR Tip': 'string', 'Kabul Eden': 'string', 'Toplam Paket Adedi': 'number', 'Hareket Yönü': 'string', 'Not': 'string' };
        await exportApiCall(rawExcelData, rawHeaders, `${mallTitle} Taşıma Raporu`);

        // --- 2. EXCEL: ÖZET PİVOT RAPORU ---
        const allTools = [...new Set(allDataRows.map(row => row[7] || '(boş)'))].sort();
        const pivotSheetContent = [];
        const reportDateRange = `(${startDate.format('DD.MM.YYYY')}-${endDate.format('DD.MM.YYYY')})`;

        // A) Araç Bazlı Özet
        const aracBazli = allDataRows.reduce((acc, row) => { acc[row[7] || '(boş)'] = (acc[row[7] || '(boş)'] || 0) + 1; return acc; }, {});
        let pivotAracData = Object.entries(aracBazli).map(([arac, sayi]) => ({ 'Taşıma Aracı': arac, 'Toplam Sefer Sayısı': sayi }));
        const aracToplam = pivotAracData.reduce((sum, item) => sum + item['Toplam Sefer Sayısı'], 0);

        pivotSheetContent.push({ A: `${mallTitle} Araç Bazlı Taşıma Raporu ${reportDateRange}` });
        pivotSheetContent.push({ A: 'Taşıma Aracı', B: 'Toplam Sefer Sayısı' });
        pivotAracData.forEach(item => pivotSheetContent.push({ A: item['Taşıma Aracı'], B: item['Toplam Sefer Sayısı'] }));
        pivotSheetContent.push({ A: 'Genel Toplam', B: aracToplam });
        pivotSheetContent.push({}, {});

        // B) Personel Bazlı Özet
        const personelBazli = allDataRows.reduce((acc, row) => { const p = row[8] || '(boş)'; const a = row[7] || '(boş)'; if (!acc[p]) acc[p] = {}; acc[p][a] = (acc[p][a] || 0) + 1; return acc; }, {});
        const personelHeaderRow = { A: `${mallTitle} Personel Bazlı Taşıma Raporu ${reportDateRange}`, B: 'Araç Tipi' };
        pivotSheetContent.push(personelHeaderRow);
        const personelColumnHeaders = { A: 'Personel Adı' };
        allTools.forEach((tool, i) => { personelColumnHeaders[String.fromCharCode(66 + i)] = tool; });
        personelColumnHeaders[String.fromCharCode(66 + allTools.length)] = 'Genel Toplam';
        pivotSheetContent.push(personelColumnHeaders);
        Object.entries(personelBazli).forEach(([personel, araclar]) => {
            const row = { A: personel };
            let total = 0;
            allTools.forEach((tool, i) => { const count = araclar[tool] || ''; row[String.fromCharCode(66 + i)] = count; total += (araclar[tool] || 0); });
            row[String.fromCharCode(66 + allTools.length)] = total;
            pivotSheetContent.push(row);
        });

        // Veri satırlarını oluşturmak için geçici bir dizi kullanıyoruz
        const personelDataRows = Object.entries(personelBazli).map(([personel, araclar]) => {
            const row = { A: personel };
            let total = 0;
            allTools.forEach((tool, i) => { 
                const count = araclar[tool] || ''; 
                row[String.fromCharCode(66 + i)] = count; 
                total += (araclar[tool] || 0); 
            });
            row[String.fromCharCode(66 + allTools.length)] = total;
            return row;
        });
        pivotSheetContent.push(...personelDataRows);

        const personelGenelToplamRow = { A: 'Genel Toplam' };
        let grandTotal = 0;
        allTools.forEach((tool, i) => {
            const colLetter = String.fromCharCode(66 + i);
            // personelDataRows dizisinden sütun toplamını hesaplıyoruz
            const toolSum = personelDataRows.reduce((sum, p) => sum + (Number(p[colLetter]) || 0), 0);
            personelGenelToplamRow[colLetter] = toolSum;
            grandTotal += toolSum;
        });
        personelGenelToplamRow[String.fromCharCode(66 + allTools.length)] = grandTotal;
        pivotSheetContent.push(personelGenelToplamRow);

        const pivotHeaders = {};
        for (let i = 0; i < allTools.length + 2; i++) { pivotHeaders[String.fromCharCode(65 + i)] = 'string'; }
        await exportApiCall(pivotSheetContent, pivotHeaders, `${mallTitle} Taşıma Özet`);
    };

    const handleGunSonuRaporu = async () => {
        const token = localStorage.getItem('tokenForService');
        const mallId = getMallId();
        const mallTitle = getMallTitleById(mallId);
        const startDateFormatted = startDate.format('YYYY-MM-DD');
        const endDateFormatted = endDate.format('YYYY-MM-DD');
        const incompleteStatusIds = ['3', '4', '5', '6', '7', '8', '9', '11', '12', '13', '14', '18', '19', '20', '26', '27', '29'];

        const response = await Services.GetPostsMall(token, mallId, incompleteStatusIds, startDateFormatted, endDateFormatted);

        if (!response.data.status || response.data.result.length === 0) {
            toast.info('Seçilen kriterlere uygun tamamlanmamış iş bulunamadı.');
            return;
        }
        const allJobs = response.data.result;

        // 1. EXCEL: HAM VERİ
        const rawDataContent = allJobs.map((row, index) => {
            let tasimaBilgisi = '-';
            if (row.usedVehicles && row.usedVehicles.length > 0) {
                tasimaBilgisi = row.usedVehicles.map(v => `${v.transportationToolCount} x ${v.transportationTool}`).join(', ');
            } else if (row.requestedTransportationTool) {
                tasimaBilgisi = `1 x ${row.requestedTransportationTool}`;
            }
            return { 'No': index + 1, 'Oluşturulma Tar.': moment.unix(row.createdDateTime).format('DD/MM/YYYY HH:mm'), 'Sip Kargo Takip No': row.barcode, 'İrsaliye No': row.handshakeID || '-', 'Firma Kişi': row.branchTitle || row.from.title, 'Çıkış Noktası': row.from.title, 'Varış Noktası': row.to.title, 'Adet Bilgisi': Number(row.orderInventory), 'Taşıma Bilgisi': tasimaBilgisi, 'Kargo Firması': row.shipmentFirm || 'Nakliye', 'Taşıyan Kişi': row.porters?.[0]?.porterNameLastname || '-', 'İşlem Durumu': StatusList.find(s => s.id.toString() === row.status)?.label || `Bilinmeyen (${row.status})` };
        });
        const rawDataHeaders = { 'No': 'number', 'Oluşturulma Tar.': 'string', 'Sip Kargo Takip No': 'string', 'İrsaliye No': 'string', 'Firma Kişi': 'string', 'Çıkış Noktası': 'string', 'Varış Noktası': 'string', 'Adet Bilgisi': 'number', 'Taşıma Bilgisi': 'string', 'Kargo Firması': 'string', 'Taşıyan Kişi': 'string', 'İşlem Durumu': 'string' };

        // 2. EXCEL: ÖZET PİVOT
        const malKabuldeBekleyenler = allJobs.filter(job => job.status === '14').reduce((acc, job) => { const firma = job.shipmentFirm || '(boş)'; acc[firma] = (acc[firma] || 0) + (Number(job.orderInventory) || 0); return acc; }, {});
        let pivotMalKabulData = Object.entries(malKabuldeBekleyenler).map(([firma, toplam]) => ({ 'Kargo Firması': firma, 'Adet Bilgisi (Toplam)': toplam }));
        const malKabulToplam = pivotMalKabulData.reduce((sum, item) => sum + item['Adet Bilgisi (Toplam)'], 0);
        pivotMalKabulData.push({ 'Kargo Firması': 'Genel Toplam', 'Adet Bilgisi (Toplam)': malKabulToplam });

        const magazateslimleri = allJobs.filter(job => job.status === '12').reduce((acc, job) => { const nokta = job.from?.title || '(boş)'; acc[nokta] = (acc[nokta] || 0) + 1; return acc; }, {});
        let pivotMagazaTeslimData = Object.entries(magazateslimleri).map(([nokta, sayi]) => ({ 'Çıkış Noktası': nokta, 'İşlem Durumu (Tümünü Say)': sayi }));
        const magazaTeslimToplam = pivotMagazaTeslimData.reduce((sum, item) => sum + item['İşlem Durumu (Tümünü Say)'], 0);
        pivotMagazaTeslimData.push({ 'Çıkış Noktası': 'Genel Toplam', 'İşlem Durumu (Tümünü Say)': magazaTeslimToplam });

        const pivotSheetContent = [
            { A: 'İşlem Durumu', B: 'Mal Kabulde Teslim Bekleyenler' },
            { A: 'Kargo Firması', B: 'Adet Bilgisi (Toplam)' },
            ...pivotMalKabulData.map(item => ({ A: item['Kargo Firması'], B: item['Adet Bilgisi (Toplam)'] })),
            {},
            { A: 'İşlem Durumu', B: 'Mağazada Teslimler' },
            { A: 'Çıkış Noktası', B: 'İşlem Durumu (Tümünü Say)' },
            ...pivotMagazaTeslimData.map(item => ({ A: item['Çıkış Noktası'], B: item['İşlem Durumu (Tümünü Say)'] }))
        ];
        const pivotHeaders = { A: 'string', B: 'string' };

        await exportApiCall(rawDataContent, rawDataHeaders, `${mallTitle} Gün Sonu Raporu`);
        await exportApiCall(pivotSheetContent, pivotHeaders, `${mallTitle} Gün Sonu Özet`);
    };

    const handlePorterPerformansRaporu = async () => {
        const token = localStorage.getItem('tokenForService');
        const mallId = getMallId();
        const mallTitle = getMallTitleById(mallId);
        const startDateFormatted = startDate.format('YYYY-MM-DD');
        const endDateFormatted = endDate.format('YYYY-MM-DD');

        const response = await Services.GetPorterPerformanceReport(token, [mallId], startDateFormatted, endDateFormatted);
        if (!response.data.status || typeof response.data.result !== 'object') {
            toast.info('Porter performans raporu için veri bulunamadı.');
            return;
        }
        const portersData = Object.values(response.data.result);
        if (portersData.length === 0) {
            toast.info('Porter performans raporu için veri bulunamadı.');
            return;
        }
        const excelData = portersData.map(porter => {
            const toplamSefer = (porter.boxTripCount || 0) + (porter.otherTransportationToolsTripCount || 0);
            const formatSecondsToMinutes = (sec) => (sec / 60).toFixed(1);
            return { 'AVM Adı': porter.mallTitle, 'Porter Adı': `${porter.name} ${porter.lastname}`, 'İmzalatılan Koli/Kargo Sefer Sayısı': porter.boxTripCount || 0, 'İmzalatılan Araç Sefer Sayısı': porter.otherTransportationToolsTripCount || 0, 'Toplam İmzalatılan İrsaliye Sayısı (Sefer Sayısı)': toplamSefer, 'İptal Edilen İş Sayısı': porter.cancelledPostCount || 0, 'Geciken İş Sayısı': porter.delayedHandshakesCount || 0, 'Ortalama Süre (dk)': formatSecondsToMinutes(porter.medianHandshakeTime || 0), 'En Kısa Süre (dk)': formatSecondsToMinutes(porter.shortestHandshakeTime || 0), 'En Uzun Süre (dk)': formatSecondsToMinutes(porter.longestHandshakeTime || 0) };
        });
        const headers = { 'AVM Adı': 'string', 'Porter Adı': 'string', 'İmzalatılan Koli/Kargo Sefer Sayısı': 'number', 'İmzalatılan Araç Sefer Sayısı': 'number', 'Toplam İmzalatılan İrsaliye Sayısı (Sefer Sayısı)': 'number', 'İptal Edilen İş Sayısı': 'number', 'Geciken İş Sayısı': 'number', 'Ortalama Süre (dk)': 'string', 'En Kısa Süre (dk)': 'string', 'En Uzun Süre (dk)': 'string' };
        await exportApiCall(excelData, headers, `${mallTitle} Porter Performans Raporu`);
    };

    const handleExport = async () => {
        if (!startDate || !endDate) {
            toast.warn('Lütfen başlangıç ve bitiş tarihlerini seçin.');
            return;
        }
        setLoading(true);
        try {
            switch (reportType) {
                case 'tasima': await handleTasimaRaporu(); break;
                case 'gunsonu': await handleGunSonuRaporu(); break;
                case 'porter': await handlePorterPerformansRaporu(); break;
                default: toast.error('Geçersiz rapor tipi seçildi.'); break;
            }
        } catch (error) {
            toast.error(error.message || 'Rapor oluşturulurken bir hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Card sx={{ p: 2, backgroundColor: 'transparent', boxShadow: 'none', borderRadius: 0 }}>
                <Stack spacing={3}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                        <Typography variant="h6">Rapor Oluştur</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, backgroundColor: '#F9FAFB', p: 2, borderRadius: 1 }}>
                        <Typography variant="body1" fontWeight="500">Rapor Seçimi</Typography>
                        <Stack sx={{ flexDirection: { xs: 'column', lg: 'row' }, alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                            <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1}>
                                <DatePicker label="Başlangıç Tarihi" value={startDate} onChange={(newValue) => setStartDate(newValue)} slots={{ openPickerIcon: CalendarIcon }} slotProps={{ textField: { size: 'small', sx: { backgroundColor: '#FFFFFF' } } }} />
                                <DatePicker label="Bitiş Tarihi" value={endDate} onChange={(newValue) => setEndDate(newValue)} slots={{ openPickerIcon: CalendarIcon }} slotProps={{ textField: { size: 'small', sx: { backgroundColor: '#FFFFFF' } } }} />
                                <Button variant="contained" onClick={handleExport}>Rapor Oluştur ( Excel )</Button>
                                <Button variant="contained" onClick={handleExport}>Rapor Oluştur ( PDF )</Button>
                            </Stack>
                        </Stack>
                    </Box>
                    <FormControl fullWidth size="small" sx={{ backgroundColor: '#FFFFFF' }}>
                        <InputLabel>Rapor Tipi</InputLabel>
                        <Select value={reportType} onChange={(e) => setReportType(e.target.value)} label="Rapor Tipi">
                            <MenuItem value="tasima">Taşıma Raporu</MenuItem>
                            <MenuItem value="gunsonu">Gün Sonu Tamamlanmayan İşler Raporu</MenuItem>
                            <MenuItem value="porter">Porter Performans Raporu</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </Card>
        </LocalizationProvider>
    );
};

// shipmentFirmsDelivered ve shipmentFirmsInMalKabul verilerini birleştiren fonksiyon
function mergeFirmData(deliveredArr, pendingArr) {
    const map = {};
    deliveredArr.forEach(item => {
        if (!item.shipmentFirm || item.shipmentFirm.trim() === "") return;
        map[item.shipmentFirm] = {
            name: item.shipmentFirm,
            delivered: Number(item.total),
            pending: 0,
        };
    });
    pendingArr.forEach(item => {
        if (!item.shipmentFirm || item.shipmentFirm.trim() === "") return;
        if (map[item.shipmentFirm]) {
            map[item.shipmentFirm].pending = Number(item.total);
        } else {
            map[item.shipmentFirm] = {
                name: item.shipmentFirm,
                delivered: 0,
                pending: Number(item.total),
            };
        }
    });
    return Object.values(map)
        .sort((a, b) => b.delivered - a.delivered)
        .slice(0, 7);
}

// Açıkta Bekleyen İşlemler oranını hesapla
function calcOpenWaitingPercent(analytics) {
    if (!analytics) return 0;
    const waiting = Number(analytics.waitingPostsCreatedByPorter || 0) + Number(analytics.waitingPostsCreatedByCorporational || 0);
    const total =
        Number(analytics.waitingPosts || 0) +
        Number(analytics.onPorterPosts || 0) +
        Number(analytics.lateWaitingPosts || 0) +
        Number(analytics.completedPosts || 0) +
        Number(analytics.cancelledPosts || 0);
    if (total === 0) return 0;
    return (waiting / total) * 100;
}

// Seçili mall'ın adını bulmak için yardımcı fonksiyon
function getMallTitleById(mallID) {
    const user = tokenService.getUser();
    const malls = user?.authLocations?.mall || [];
    const mall = malls.find(m => m.id === mallID);
    return mall ? mall.title : '';
}

// Tamamlanan İşler DonutChart'ı için araç tiplerinin toplamını hesapla
function getCompletedVehicleTotals(livePostTracking) {
    const totals = {};
    if (Array.isArray(livePostTracking)) {
        livePostTracking.forEach(item => {
            if (!item.transportationTool) return;
            if (!totals[item.transportationTool]) totals[item.transportationTool] = 0;
            totals[item.transportationTool] += Number(item.transportationToolCount || 1);
        });
    }
    // Sıfırdan büyük olanları döndür
    return Object.entries(totals)
        .filter(([_, val]) => val > 0)
        .map(([name, value], idx) => ({
            name,
            value,
            color: [
                '#61C6F2', '#C1D3F8', '#2265E7', '#F79009', '#A259F7', '#FF6B6B', '#00B8D9', '#FFC542', '#6E7C7C', '#BDBDBD'
            ][idx % 10]
        }));
}

// DonutChart için shipmentFirmsDelivered ve shipmentFirmsInMalKabul toplamlarını hesaplayan fonksiyon
function getMalKabulDonutData(shipmentFirmsDelivered, shipmentFirmsInMalKabul) {
    const deliveredTotal = Array.isArray(shipmentFirmsDelivered)
        ? shipmentFirmsDelivered.reduce((acc, cur) => acc + Number(cur.total || 0), 0)
        : 0;
    const pendingTotal = Array.isArray(shipmentFirmsInMalKabul)
        ? shipmentFirmsInMalKabul.reduce((acc, cur) => acc + Number(cur.total || 0), 0)
        : 0;
    return [
        { name: 'Teslim Edilen Paketler', value: deliveredTotal, color: '#61C6F2' },
        { name: 'Bekleyen Paketler', value: pendingTotal, color: '#F79009' }
    ];
}

// ----------------------------------------------------------------------
// Ana Bileşen
// ----------------------------------------------------------------------

export default function LiveOperationTracking() {
    const theme = useTheme();
    const [analytics, setAnalytics] = useState(null);
    const [loading, setLoading] = useState(true);

    const [mallID] = useState(getMallId());
    const mallTitle = getMallTitleById(mallID);

    useEffect(() => {
        const token = localStorage.getItem('tokenForService');

        if (!mallID || !token) {
            setAnalytics(null);
            setLoading(false);
            return;
        }

        setLoading(true);
        Services.GetLiveAnalyticsPorter(token, mallID)
            .then(res => {
                if (res.data.status) {
                    // API'dan 'false' gibi değerler gelme ihtimaline karşı veriyi güvenli hale getirelim.
                    const result = res.data.result;
                    result.shipmentFirmsInMalKabul = Array.isArray(result.shipmentFirmsInMalKabul) ? result.shipmentFirmsInMalKabul : [];
                    result.shipmentFirmsDelivered = Array.isArray(result.shipmentFirmsDelivered) ? result.shipmentFirmsDelivered : [];
                    result.livePostTracking = Array.isArray(result.livePostTracking) ? result.livePostTracking : [];
                    if (result.porterDailyPerformance) {
                        result.porterDailyPerformance.portersPostCompletionMedian = Array.isArray(result.porterDailyPerformance.portersPostCompletionMedian) ? result.porterDailyPerformance.portersPostCompletionMedian : [];
                    } else {
                        result.porterDailyPerformance = { allPorterPostCompletionMedian: 0, portersPostCompletionMedian: [] };
                    }

                    setAnalytics(result);
                } else {
                    setAnalytics(null);
                    toast.error(res.data.message || 'Veriler alınamadı.');
                }
            })
            .catch((err) => {
                setAnalytics(null);
                toast.error("Veriler yüklenirken bir hata oluştu.");
                console.error(err);
            })
            .finally(() => setLoading(false));
    }, []);

    const densityPercentage = analytics?.densityPercentage ? Number(analytics.densityPercentage) : 0;
    const openWaitingPercent = calcOpenWaitingPercent(analytics);
    const groupedBarData = mergeFirmData(analytics?.shipmentFirmsDelivered || [], analytics?.shipmentFirmsInMalKabul || []);
    const cancelReasonsData = Object.entries(analytics?.cancelReasons || {}).map(([name, value]) => ({ name, value, color: name === 'Yanlış Adet' ? '#1C64F2' : name === 'Yanlış Yön' ? '#82ACFF' : name === 'Çift İş Emri' ? '#92D1F3' : '#2265E7' }));
    const livePostTracking = analytics?.livePostTracking || [];
    const portersPostCompletionMedian = analytics?.porterDailyPerformance?.portersPostCompletionMedian || [];
    const allPorterPostCompletionMedian = analytics?.porterDailyPerformance?.allPorterPostCompletionMedian || 0;
    const completedVehicleTotals = getCompletedVehicleTotals(livePostTracking);
    const malKabulDonutData = getMalKabulDonutData(analytics?.shipmentFirmsDelivered || [], analytics?.shipmentFirmsInMalKabul || []);

    const summaryData = [
        { title: 'Bekleyen İşlemler', color: '#D18B28', value: loading ? '...' : analytics?.waitingPosts ?? '0', chart: <RedLineChartSvg /> },
        { title: 'Porter Üzerinde İşlem', color: '#5885D9', value: loading ? '...' : analytics?.onPorterPosts ?? '0', chart: <GreenLineChartSvg /> },
        { title: 'Gecikmiş İşlemler', color: '#E49C27', value: loading ? '...' : analytics?.lateWaitingPosts ?? '0', chart: <GreenLineChartSvg /> },
        { title: 'Teslim Edilen İşlemler', color: '#47A45D', value: loading ? '...' : analytics?.completedPosts ?? '0', chart: <GreenLineChartSvg /> },
        { title: 'İptal Edilen İşlemler', color: '#DC5445', value: loading ? '...' : analytics?.cancelledPosts ?? '0', chart: <RedLineChartSvg /> },
        { title: 'İptal Oranı', color: '#DC5445', value: loading ? '...' : (analytics ? `${Math.round((Number(analytics.cancelledPosts || 0) / (Number(analytics.completedPosts || 1) + Number(analytics.cancelledPosts || 0)) * 100))}%` : '0%'), chart: <RedLineChartSvg /> }
    ];

    return (
        <HelmetProvider>
            <Helmet><title> Canlı Operasyon Takibi | Mall Logistics Panel </title></Helmet>
            <Stack sx={{ p: { xs: 2, md: 3 }, width: '100%' }} spacing={2}>
                {loading ? (
                    <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', bgcolor: 'rgba(255,255,255,0.7)', zIndex: 1300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress size={64} />
                    </Box>
                ) : (
                    <Stack spacing={2}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <Typography variant="h4">İşlem Önizlemeleri</Typography>
                            <Typography variant="subtitle1" color="text.secondary" sx={{ display: { xs: 'none', md: 'block' } }}>
                                {mallTitle}
                            </Typography>
                        </Box>
                        <Grid container spacing={2} alignItems={'stretch'}>
                            <Grid item xs={12} lg={9}>
                                <Grid container spacing={2}>
                                    {summaryData.map((item) => (
                                        <Grid item xs={12} sm={6} md={4} key={item.title}>
                                            <Card sx={{ padding: '16px 15px 12px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>
                                                <Box><Typography variant="subtitle2" color={item.color} noWrap>{item.title}</Typography><Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}><BoxIcon size={32} color={theme.palette.text.secondary} /><Typography variant="h4">{item.value}</Typography></Stack></Box>
                                                <Box sx={{ ml: 1 }}>{item.chart}</Box>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <OperationDensityChart percentage={densityPercentage} />
                            </Grid>
                        </Grid>
                    </Stack>
                )}

                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} lg={3}>
                        <Stack spacing={2} sx={{ height: '100%' }}>
                            <GaugeChart
                                title="Açıkta Bekleyen İşlemler"
                                value={`${openWaitingPercent.toLocaleString('tr-TR', { maximumFractionDigits: 1 })}%`}
                                subValue="Mağazanın Açtığı"
                                percentage={openWaitingPercent}
                                legendItems={[{ name: 'Mağazanın Açtığı', color: '#2265E7' }, { name: 'Porterin Açtığı', color: '#C1D3F8' }]}
                            />
                            <DonutChart
                                title="İptal Nedenleri Oranları"
                                data={cancelReasonsData}
                                size={125}
                                showTotalInCenter
                            />
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6}>
                        <GroupedBarChart data={groupedBarData} />
                    </Grid>

                    <Grid item xs={12} md={12} lg={3}>
                        <Stack spacing={2} sx={{ height: '100%' }}>
                            <DonutChart
                                title="Tamamlanan İşler"
                                value={`${completedVehicleTotals.reduce((acc, cur) => acc + cur.value, 0)} Adet`}
                                subValue={completedVehicleTotals.length > 0 ? completedVehicleTotals[0].name : ''}
                                size={150}
                                data={completedVehicleTotals}
                            />
                            <DonutChart
                                title="Mal Kabulde Bulunan Gönderiler"
                                value={`${malKabulDonutData.reduce((acc, cur) => acc + cur.value, 0)} Adet`}
                                subValue={malKabulDonutData.length > 0 ? malKabulDonutData[0].name : ''}
                                size={150}
                                data={malKabulDonutData}
                            />
                        </Stack>
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LiveTrackingTable livePostTracking={livePostTracking} />
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <PorterWorkloadChart livePostTracking={livePostTracking} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <PorterCompletionChart portersPostCompletionMedian={portersPostCompletionMedian} allPorterPostCompletionMedian={allPorterPostCompletionMedian} />
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <ReportGenerator />
                    </Grid>
                </Grid>

            </Stack>
        </HelmetProvider>
    );
}
